import {clientLog} from "../clientLog";
import {getStatusIcon} from "./publishStatus";

/**
 * Get human-readable publishing state.
 * @param t
 * @param label
 * @param state
 * @param icons
 * @returns {*|string}
 */
export const getHrPublishingState = (t, label, state, icons = false) => {

    let icon = null;

    if (icons) {
        icon = getStatusIcon(state);
    }

    let outLabel = '';
    state = state === 'done' ? 'success' : state;
    switch (state) {
        case 'pending':
            outLabel = t('publishingStatePending', 'Prosesserer');
            break;
        case 'success':
            outLabel = t('publishingStateSuccess', 'Fullført');
            break;
        case 'failed':
            outLabel = t('publishingStateFailed', 'Feilet');
            break;
        default:
            clientLog('warning',
                `getHrPublishingState: Unknown state: ${state}`,
                'gethrpublishingstate');
            break;
    }

    if (icon !== null) {
        return <>{icon} {label}</>;
    } else if (label === '') {
        return <>{outLabel.toLowerCase()}</>;
    } else {
        return <>{label} - {outLabel.toLowerCase()}</>;
    }
};